// src/Components/Bookmakers/Bookmakers.js
// FIXED: Hidden on iOS to comply with Apple Guideline 5.3.4 (Gambling)

import React from 'react';
import { Icon } from '@iconify/react';
import { Capacitor } from '@capacitor/core';
import './Bookmakers.css';

const Bookmakers = () => {
    // 🔥 HIDE ON iOS - Apple Guideline 5.3.4
    const isIOS = Capacitor.getPlatform() === 'ios';
    
    if (isIOS) {
        return null; // Don't render anything on iOS
    }

    // Links (affiliate links)
    const bookies = [
        { 
            name: 'SportyBet', 
            icon: 'solar:football-linear',
            color: '#e72828',
            url: 'https://www.sportybet.com' 
        },
        { 
            name: '22Bet', 
            icon: 'fluent:sport-soccer-24-regular', 
            color: '#009088',
            url: 'https://22bet.com' 
        },
        { 
            name: 'Stake', 
            icon: 'simple-icons:stake', 
            color: '#146ef5',
            url: 'https://stake.com' 
        },
        { 
            name: 'Bet365', 
            icon: 'simple-icons:bet365', 
            color: '#247f4f',
            url: 'https://www.bet365.com' 
        }
    ];

    return (
        <div className="bookmakers">
            <p className="bookmakers__label">
                <Icon icon="solar:card-send-linear" />
                <span>Quick Bet</span>
            </p>
            <div className="bookmakers__grid">
                {bookies.map((bookie, index) => (
                    <a 
                        key={index} 
                        href={bookie.url} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="bookmaker-chip"
                        style={{ '--brand-color': bookie.color }}
                    >
                        <Icon icon={bookie.icon} className="bookmaker-icon" />
                        <span className="bookmaker-name">{bookie.name}</span>
                        <Icon icon="solar:arrow-right-up-linear" className="bookmaker-arrow" />
                    </a>
                ))}
            </div>
        </div>
    );
};

export default Bookmakers;